// Container imports
const HeroSectionRecord = require('./record')

function heroSectionReducer(state = new HeroSectionRecord(), action) {
  switch (action.type) {
    // No actions; this reducer exists to silence a react-redux warning for now.
    default:
      return state
  }
}

module.exports = heroSectionReducer
